import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'ml-row-checkbox, [row-checkbox]',
  templateUrl: './row-checkbox.component.html',
  styleUrls: ['./row-checkbox.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  imports: [ReactiveFormsModule],
})
export class RowCheckboxComponent {
  @Input() description: string;
  @Input() id: string;
  @Input() editing = false;
  @Input() label: string;
}
